import { render, staticRenderFns } from "./completedHomeworkItem.vue?vue&type=template&id=3e82bca2&scoped=true"
import script from "./completedHomeworkItem.vue?vue&type=script&lang=js"
export * from "./completedHomeworkItem.vue?vue&type=script&lang=js"
import style0 from "./completedHomeworkItem.vue?vue&type=style&index=0&id=3e82bca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82bca2",
  null
  
)

export default component.exports